import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { SharedRoutingModule } from "./shared-routing.module";
import { UnderConstructionComponent } from "./under-construction/under-construction.component";
import { PzTabBarComponent } from "./sharedPzTab/pz-tab-bar/pz-tab-bar.component";
import { ConfirmationModalComponent } from "./ui/confirmation-modal/confirmation-modal.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  declarations: [
    UnderConstructionComponent,
    PzTabBarComponent,
    ConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    NgxSkeletonLoaderModule,
    MatButtonModule,
    MatDialogModule,
  ],
  exports: [
    UnderConstructionComponent,
    PzTabBarComponent,
    ConfirmationModalComponent,
  ],
})
export class SharedModule {}
